import React from 'react';
import { Store } from 'lucide-react';
import { Restaurant } from '../types';
import { useAuth } from '@/shared/contexts/AuthContext';

interface OrderParserHeaderProps {
  step: 'select' | 'parse' | 'confirm' | 'success';
  selectedRestaurant: Restaurant | null;
  onNewOrder: () => void;
}

export const OrderParserHeader: React.FC<OrderParserHeaderProps> = ({
  step,
  selectedRestaurant
}) => {
  const isSuccess = step === 'success';
  const { user, restaurant } = useAuth();

  const displayName =
    user?.business_name || restaurant?.business_name || 'Order Parser';

  return (
    <header className="bg-[#006B82]  text-white shadow-lg sticky top-0 z-50">
      <div className="px-3 sm:px-6 py-4 sm:py-2 flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3 sm:gap-4">
        <div className="flex items-start justify-between">
          <div>
            <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight flex items-center gap-2 sm:gap-3">
              <span className="hidden xs:inline">
                {isSuccess ? 'Order Created!' : displayName || 'Order Parser'}
              </span>
              <span className="xs:hidden">
                {isSuccess ? 'Success!' : displayName || 'Create Order'}
              </span>
            </h1>
            {/* <p className="mt-1 sm:mt-3 text-white/80 text-sm sm:text-lg">
                            {isSuccess
                                ? 'Your order has been created successfully'
                                : authType === 'supplier'
                                    ? `Creating order for ${selectedRestaurant?.business_name || 'a restaurant'}`
                                    : 'Create orders for your restaurant'}
                        </p> */}
          </div>
          {/* <button
                        onClick={onNewOrder}
                        className="sm:hidden p-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors"
                        title={isSuccess ? 'New Order' : 'Reset'}
                    >
                        <RefreshCw className="w-5 h-5" />
                    </button> */}
        </div>
        {/* <div className="flex items-center gap-3 sm:gap-4">
                    {selectedRestaurant && (
                        <div className="hidden sm:block text-right">
                            <p className="text-sm text-white">{selectedRestaurant.business_name}</p>
                            <p className="text-xs text-white/70">Creating order for</p>
                        </div>
                    )}
                    <button
                        onClick={onNewOrder}
                        className="hidden sm:flex px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg text-sm font-medium transition-colors items-center gap-2"
                    >
                        <RefreshCw className="w-4 h-4" />
                        {isSuccess ? 'New Order' : 'Reset'}
                    </button>
                </div> */}
      </div>
      {/* Mobile restaurant badge */}
      {selectedRestaurant && (
        <div className="sm:hidden px-3 pb-3">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/10 rounded-lg">
            <Store className="w-4 h-4" />
            <span className="text-sm text-white">
              {selectedRestaurant.business_name}
            </span>
          </div>
        </div>
      )}
    </header>
  );
};
